import {useEffect, useMemo, useRef} from "react";

import {RegionType} from "../../../region/types/RegionType";
import {useGetMapRegionsQuery} from "../api/get_map_region";
import {useGetMapRegionDistrictsAndSurroundingsQuery} from "../api/get_map_region_districts_and_surroundings";
import {getMainCityBySelectedRegions} from "../utils/districts_and_surroundings/get_main_city_by_selected_regions";
import {ISelectedRegionParam} from "../utils/districts_and_surroundings/get_region_parent_id";
import {validateSelectedRegionsWithAvailableDistrictsAndSurroundings} from "../utils/districts_and_surroundings/validate_selected_regions_with_available_districts_and_surroundings";

interface IProps {
    selectedRegions?: ISelectedRegionParam[] | null;
}

type IWaitForRegionCallback = (props: {hasValidSurroundings?: boolean; hasAnyValidDistricts?: boolean}) => void;

export const useMapRegionDistrictsAndSurroundings = (props: IProps) => {
    const newRegionCallbackQ = useRef<IWaitForRegionCallback[]>([]);

    const parentId = useMemo(() => {
        if (!props.selectedRegions) {
            return null;
        }

        return getMainCityBySelectedRegions(props.selectedRegions);
    }, [props.selectedRegions]);

    const {data: mainRegionData, isLoading: isMainRegionLoading} = useGetMapRegionsQuery({region: parentId || 0}, {skip: !parentId});
    const {data, isLoading, error} = useGetMapRegionDistrictsAndSurroundingsQuery({parent: parentId || 0}, {skip: !parentId});

    const regions = useMemo(() => {
        if (!data || !mainRegionData) {
            return {
                districts: [],
                surroundings: [],
                main: null
            };
        }

        return {
            districts: data.results.filter((region) => region.type === RegionType.DISTRICT),
            surroundings: data.results.filter((region) => region.type !== RegionType.DISTRICT),
            main: mainRegionData?.results[0] || null
        };
    }, [data, mainRegionData]);

    useEffect(() => {
        if (isLoading || isMainRegionLoading) {
            return;
        }

        const hasValidSurroundings = validateSelectedRegionsWithAvailableDistrictsAndSurroundings(props.selectedRegions || [], data?.results);
        const hasAnyValidDistricts = !!data?.results.some((region) => region.type === RegionType.DISTRICT);
        newRegionCallbackQ.current.forEach((callback) =>
            callback({
                hasValidSurroundings,
                hasAnyValidDistricts
            })
        );
        newRegionCallbackQ.current = [];
    }, [isLoading, isMainRegionLoading, data, parentId]);

    return {
        hasAnyDistrictsOrSurroundings: regions.districts.length > 0 || regions.surroundings.length > 0,
        regions,
        data,
        isLoading: isLoading || isMainRegionLoading,
        error,
        parentId,
        waitForRegion: (callback: IWaitForRegionCallback) => {
            newRegionCallbackQ.current.push(callback);
        }
    };
};
import {useEffect, useMemo, useRef} from "react";

import {RegionType} from "../../../region/types/RegionType";
import {useGetMapRegionsQuery} from "../api/get_map_region";
import {useGetMapRegionDistrictsAndSurroundingsQuery} from "../api/get_map_region_districts_and_surroundings";
import {getMainCityBySelectedRegions} from "../utils/districts_and_surroundings/get_main_city_by_selected_regions";
import {ISelectedRegionParam} from "../utils/districts_and_surroundings/get_region_parent_id";
import {validateSelectedRegionsWithAvailableDistrictsAndSurroundings} from "../utils/districts_and_surroundings/validate_selected_regions_with_available_districts_and_surroundings";

interface IProps {
    selectedRegions?: ISelectedRegionParam[] | null;
}

type IWaitForRegionCallback = (props: {hasValidSurroundings?: boolean; hasAnyValidDistricts?: boolean}) => void;

export const useMapRegionDistrictsAndSurroundings = (props: IProps) => {
    const newRegionCallbackQ = useRef<IWaitForRegionCallback[]>([]);

    const parentId = useMemo(() => {
        if (!props.selectedRegions) {
            return null;
        }

        return getMainCityBySelectedRegions(props.selectedRegions);
    }, [props.selectedRegions]);

    const {data: mainRegionData, isLoading: isMainRegionLoading} = useGetMapRegionsQuery({region: parentId || 0}, {skip: !parentId});
    const {data, isLoading, error} = useGetMapRegionDistrictsAndSurroundingsQuery({parent: parentId || 0}, {skip: !parentId});

    const regions = useMemo(() => {
        if (!data || !mainRegionData) {
            return {
                districts: [],
                surroundings: [],
                main: null
            };
        }

        return {
            districts: data.results.filter((region) => region.type === RegionType.DISTRICT),
            surroundings: data.results.filter((region) => region.type !== RegionType.DISTRICT),
            main: mainRegionData?.results[0] || null
        };
    }, [data, mainRegionData]);

    useEffect(() => {
        if (isLoading || isMainRegionLoading) {
            return;
        }

        const hasValidSurroundings = validateSelectedRegionsWithAvailableDistrictsAndSurroundings(props.selectedRegions || [], data?.results);
        const hasAnyValidDistricts = !!data?.results.some((region) => region.type === RegionType.DISTRICT);
        newRegionCallbackQ.current.forEach((callback) =>
            callback({
                hasValidSurroundings,
                hasAnyValidDistricts
            })
        );
        newRegionCallbackQ.current = [];
    }, [isLoading, isMainRegionLoading, data, parentId]);

    return {
        hasAnyDistrictsOrSurroundings: regions.districts.length > 0 || regions.surroundings.length > 0,
        regions,
        data,
        isLoading: isLoading || isMainRegionLoading,
        error,
        parentId,
        waitForRegion: (callback: IWaitForRegionCallback) => {
            newRegionCallbackQ.current.push(callback);
        }
    };
};
